<button
  mat-stroked-button
  [disabled]="!eligibleInvoices.length || (estimateService.estimateLoading$ | async)"
  [matMenuTriggerFor]="eligibleInvoices.length > 1 ? printInvoicesMenu : null"
  (click)="onPrintClick()"
>
  <mat-icon>print</mat-icon>
  <span>{{ 'common.print' | translate }}</span>
</button>

<mat-menu #printInvoicesMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let invoice of eligibleInvoices"
    (click)="printInvoice(invoice)"
  >
    <mat-icon>description</mat-icon>
    <span>{{ invoice.shortId | shortId }}</span>
  </button>
</mat-menu>
